const func = ($target) => {
    $(document).ready(function () {
        const $audio = $('#podcast-audio');
        const $playPauseBtn = $('.play-pause-btn');
        const $progress = $('#progress');
        const $progressBar = $('.progress-bar');
        const $currentTime = $('#current-time');
        const $leftTime = $('#left-time');
        let isPlaying = false;

        const duration = $audio[0].duration;
        const durationMinutes = Math.floor(duration / 60);
        const durationSeconds = Math.floor(duration % 60);
        
        $leftTime.text(`-${durationMinutes}:${durationSeconds.toString().padStart(2, '0')}`);
    
        $playPauseBtn.on('click', function () {
            if (isPlaying) {
                $audio[0].pause();
                $playPauseBtn.html($('.play-pause-btn').data('icon-start'));
            } else {
                $audio[0].play();
                $playPauseBtn.html($('.play-pause-btn').data('icon-pause'));
            }
            isPlaying = !isPlaying;
        });

        $audio.on('pause', function () {
            isPlaying = false;
            $playPauseBtn.html($('.play-pause-btn').data('icon-start'));
        })

        $audio.on('timeupdate', function () {
            const currentTime = $audio[0].currentTime;
            const duration = $audio[0].duration;
            const progressPercent = (currentTime / duration) * 100;
    
            $progress.css('width', `${progressPercent}%`);
    
            const currentMinutes = Math.floor(currentTime / 60);
            const currentSeconds = Math.floor(currentTime % 60);

            const elapsedSeconds = Math.floor(duration - currentTime);
            const leftMinutes = Math.floor(elapsedSeconds / 60);
            const leftSeconds = elapsedSeconds % 60;

            $currentTime.text(`${currentMinutes}:${currentSeconds.toString().padStart(2, '0')}`);
            $leftTime.text(`-${leftMinutes}:${leftSeconds.toString().padStart(2, '0')}`);
                    
            if(currentTime == duration){
                $playPauseBtn.html($('.play-pause-btn').data('icon-start'));
            }
        });
    
        $progressBar.on('click', function (e) {
            const rect = this.getBoundingClientRect();
            const offsetX = e.clientX - rect.left;
            const totalWidth = rect.width;
            const clickPercent = offsetX / totalWidth;
            $audio[0].currentTime = clickPercent * $audio[0].duration;
        });
    
        $audio.on('loadedmetadata', function () {
            const duration = $audio[0].duration;
            const durationMinutes = Math.floor(duration / 60);
            const durationSeconds = Math.floor(duration % 60);
            $currentTime.text("0:00");
            $leftTime.text(`${durationMinutes}:${durationSeconds.toString().padStart(2, '0')}`);
        });
    });
}
export default func;
    